<template>

  <v-container>

    <dashboard></dashboard>

  </v-container>

</template>

<script>



    import Dashboard from '@/components/_dashboard/dashboard_component.vue'

    export default {

        components: {

            Dashboard

        },
        metaInfo () {
            return {
                title: 'Dashboard'
            }
        },
        computed: {},
        mounted: function () {},
        methods: {




        }
    }
</script>
